import { Box, Button, Collapse, IconButton, Typography } from "@mui/material";
import { FC, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import RenderFilterChips from "./renderFilterChips";

type ExpandableFilterProps = {
  main_title: string;
  button_title: string;
  filters: any;
  handleReset: () => void;
  isAdvanced?: boolean;
  onChipDelete?: (key: string, value: string | number, index?: number) => void;
}

const ExpandableFilter: FC<ExpandableFilterProps> = ({
  main_title,
  button_title,
  filters,
  isAdvanced = false,
  handleReset,
  onChipDelete
}) => {

  const [open, setOpen] = useState(true);

  return (
    <Box sx={{
      border: 1,
      borderRadius: 1,
      borderColor: '#1D1B20',
    }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'space-between', p: 1 ,ml: 2}}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography sx={{ fontWeight: 700, fontStyle: 'bold', fontSize: '16px', lineHeight: '20px' }}>{main_title}</Typography>
          <Button
            variant="outlined"
            sx={{
              borderRadius: 5,
              textTransform: "none",
              fontSize: "13px",
              paddingX: 2,
              borderColor: '#5921F2',
              color: '#5921F2'
            }}
            onClick={handleReset}
          >
            {button_title}
          </Button>
        </Box>

        <IconButton onClick={() => setOpen(!open)}>
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box>
          <Box
            sx={{
              width: "100%",
              borderBottom: "1px solid #1D1B20",
              mb: 2,
            }}
          />
          <Box sx={{ display: "flex", flexWrap: "wrap", p: 1 ,ml:1}}>
            <RenderFilterChips
              data={filters}
              isSeprate={true}
              isAdvanced={isAdvanced}
              isCloseable={true}
              onChipDelete={onChipDelete}
            />
          </Box>
        </Box>
      </Collapse>
    </Box>
  );

};

export default ExpandableFilter;
